import React, { useEffect, useState } from 'react';
import CanvasText from '../../components/common/CanvasText';
import { getCompanyInfo } from '../../api/config';

const Privacy = () => {
    const [info, setInfo] = useState({
        representative: '손지웅',
        email: 'hi@ggusol.com'
    });

    useEffect(() => {
        // 맨 위로 올리는 것은 ScrollManager 가 모든 페이지에 대해 한다.
        const fetchInfo = async () => {
            try {
                const data = await getCompanyInfo();
                if (data) {
                    setInfo(prev => ({
                        ...prev,
                        ...data
                    }));
                }
            } catch (err) {
                console.error('Failed to load privacy info', err);
            }
        };
        fetchInfo();
    }, []);

    const styles = {
        container: {
            maxWidth: '800px',
            margin: '0 auto',
            padding: '4rem 2rem',
            lineHeight: '1.6',
            color: '#333',
            fontFamily: 'Pretendard, sans-serif'
        },
        title: {
            fontSize: '2rem',
            fontWeight: 'bold',
            marginBottom: '2rem',
            paddingBottom: '1rem',
            borderBottom: '2px solid #333'
        },
        section: {
            marginBottom: '2.5rem'
        },
        sectionTitle: {
            fontSize: '1.2rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            color: '#1a237e'
        },
        text: {
            marginBottom: '0.5rem',
            fontSize: '1rem',
            color: '#555'
        },
        list: {
            paddingLeft: '1.5rem',
            marginBottom: '1rem'
        },
        listItem: {
            marginBottom: '0.5rem',
            color: '#555'
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '1rem',
            marginBottom: '1rem',
            fontSize: '0.9rem'
        },
        th: {
            border: '1px solid #ddd',
            padding: '10px',
            backgroundColor: '#f5f5f5',
            fontWeight: 'bold',
            textAlign: 'left'
        },
        td: {
            border: '1px solid #ddd',
            padding: '10px'
        }
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>개인정보처리방침</h1>

            <p style={styles.text}>
                '가까운솔루션'(이하 '회사')은(는) 개인정보보호법 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
            </p>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>제1조 (개인정보의 처리 목적)</h2>
                <p style={styles.text}>회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
                <ol style={styles.list}>
                    <li style={styles.listItem}><strong>재화 또는 서비스 제공</strong><br />예상 견적서 산출 및 발송, 맞춤형 서비스 제공, 서비스에 대한 상담 및 문의 응대(견적 상담, 방문 상담 등)를 목적으로 개인정보를 처리합니다.</li>
                    <li style={styles.listItem}><strong>마케팅 및 광고에의 활용</strong><br />신규 서비스(제품) 개발 및 맞춤 서비스 제공 등을 목적으로 개인정보를 처리합니다.</li>
                </ol>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>제2조 (개인정보의 처리 및 보유 기간)</h2>
                <p style={styles.text}>회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>
                <p style={styles.text}>각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>고객 상담 및 견적 산출 서비스 : <strong>3년</strong> (문의 내용 확인 및 상담 이력 관리)</li>
                </ul>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>제3조 (처리하는 개인정보의 항목)</h2>
                <p style={styles.text}>회사는 다음의 개인정보 항목을 처리하고 있습니다.</p>
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={styles.th}>수집 목적</th>
                            <th style={styles.th}>필수 항목</th>
                            <th style={styles.th}>선택 항목</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={styles.td}>견적 산출 및 상담 문의</td>
                            <td style={styles.td}>이메일</td>
                            <td style={styles.td}>성명(담당자명), 휴대전화번호, 회사/기관명</td>
                        </tr>
                    </tbody>
                </table>
                <p style={styles.text}><br />* 회사/기관명은 법적으로 개인정보에 해당하지 않을 수 있으나, 업무 처리 및 식별을 위해 수집할 수 있습니다.</p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>제4조 (개인정보의 파기)</h2>
                <p style={styles.text}>회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>제5조 (개인정보 보호책임자)</h2>
                <p style={styles.text}>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
                <div style={{ backgroundColor: '#f9f9f9', padding: '1.5rem', borderRadius: '8px', marginTop: '1rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
                        <strong style={{ width: '80px' }}>성명 : </strong>
                        <CanvasText text={info.representative} font="16px Pretendard" type="copy" />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
                        <strong style={{ width: '80px' }}>직책 : </strong>
                        <span>책임자</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={{ width: '80px' }}>연락처 : </strong>
                        <CanvasText text={info.email} font="16px Pretendard" type="email" />
                    </div>
                </div>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>제6조 (개인정보 처리방침 변경)</h2>
                <p style={styles.text}>이 개인정보 처리방침은 2026년 1월 1일부터 적용됩니다.</p>
            </div>
        </div>
    );
};

export default Privacy;
